<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view />
  </div>
</template>

<script>
import navBar from "@/components/navBar";
export default {
  name: "App",
  components: { navBar },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

html {
  width: 100%;
  height: 100%;
  font-size: 0;
  font-family: ":Microsoft YaHei";
}

body {
  width: 100%;
  height: 100%;
  min-width: 1400px;
  overflow-x: auto;
}

.container {
  width: 1280px;
  margin: 0 auto;
}

.flex-d-c {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#app {
}

.animate__animated.animate__slideInLeft {
  --animate-duration: 0.6s;
}
.animate__animated.animate__slideInRight {
  --animate-duration: 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue